import {
  FlexRow,
  Col,
  Box,
  Body,
  Divider,
  PaxIcon,
  ArrowDoubleIcon,
  ArrowRightTailIcon,
  Money,
} from '@edreamsodigeo/prisma-design-system';
import React from 'react';
import {
  useItinerarySelector,
  useOffer,
} from '@/providers/PriceFreezeOfferProvider';
import { isRoundTrip } from '@/selectors';

import { useTranslation } from '@edreamsodigeo/frontend-core';
import { PriceFreezeDate } from '@/components/PriceFreezeDateTime/PriceFreezeDateTime';

function ArrowIcon() {
  const itinerary = useItinerarySelector((itinerary) => itinerary);
  const isRt = isRoundTrip(itinerary);

  return isRt ? (
    <ArrowDoubleIcon
      data-testid="arrow-rt"
      size="small"
      color="neutral.100"
      sx={{ paddingLeft: '2x_small', paddingRight: '2x_small' }}
    />
  ) : (
    <ArrowRightTailIcon
      data-testid="arrow-ow"
      size="small"
      color="neutral.100"
      sx={{ paddingLeft: '2x_small', paddingRight: '2x_small' }}
    />
  );
}

function ItineraryDates({ departureDate, arrivalDate }) {
  const itinerary = useItinerarySelector((itinerary) => itinerary);
  const isRt = isRoundTrip(itinerary);
  const guion = ' - ';

  return isRt ? (
    <>
      <PriceFreezeDate format={'EEEddMM'} date={departureDate} />
      {guion}
      <PriceFreezeDate format={'EEEddMM'} date={arrivalDate} />
    </>
  ) : (
    <PriceFreezeDate format={'EEEddMM'} date={departureDate} />
  );
}

export function ItineraryHeader({
  departure,
  destination,
  departureDate,
  arrivalDate,
  numberOfPax,
}) {
  const { t } = useTranslation();
  const offer = useOffer();
  return (
    <>
      <Box
        py="1x_small"
        px="1x_small"
        backgroundColor="white"
        aria-label="isWebView"
      >
        <FlexRow flexDirection="row" alignItems="center" width="100%">
          <Col flexGrow={1}>
            <FlexRow flexDirection="row" alignItems="center" width="100%">
              <Col>
                <Body
                  as="span"
                  inline
                  type="small"
                  weight="medium"
                  color="neutral.90"
                >
                  {departure}
                </Body>
              </Col>
              <Col>
                <ArrowIcon />
              </Col>
              <Col>
                <Body
                  as="span"
                  inline
                  type="small"
                  weight="medium"
                  color="neutral.100"
                >
                  {destination}
                </Body>
              </Col>
            </FlexRow>
          </Col>
          <Col flexGrow={1} textAlign="right">
            <Body textAlign="right">
              <Money size="tiny" currency={offer.frozenPrimePrice.currency}>
                {offer.frozenPrimePrice.amount}
              </Money>
            </Body>
          </Col>
        </FlexRow>

        <FlexRow flexDirection="row" alignItems="center" width="100%">
          <Col flexGrow={2}>
            <Body
              as="span"
              inline
              type="xSmall"
              weight="normal"
              color="neutral.80"
              sx={{ marginRight: 'base' }}
            >
              <ItineraryDates
                departureDate={departureDate}
                arrivalDate={arrivalDate}
              />
            </Body>
            <Body as="span" inline>
              <Body
                as="span"
                inline
                type="xSmall"
                weight="normal"
                color="neutral.80"
                sx={{ verticalAlign: 'middle' }}
              >
                <PaxIcon
                  size="small"
                  color="neutral.80"
                  verticalAlign="text-bottom"
                ></PaxIcon>
              </Body>
              <Body
                as="span"
                inline
                type="xSmall"
                weight="normal"
                color="neutral.80"
              >
                {numberOfPax}
              </Body>
            </Body>
          </Col>
          <Col flexGrow={1} textAlign="right">
            <Body textAlign="right">
              <Body textAlign="end" type="xSmall" color="positive.50">
                {t('header.webviewapp.totalprimeprice')}
              </Body>
            </Body>
          </Col>
        </FlexRow>
      </Box>
      <Divider orientation="horizontal" type="solid" color="neutral.50" />
    </>
  );
}
